import styled from 'styled-components';
import colors from 'constants/colors';

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 81px;
  text-decoration: none;
  cursor: pointer;
  
  .alertBody {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    padding: 13px 5px;
    width: 100%;
    min-width: 187px;
    position: relative;

    &:before {
      content: '';
      background-color: ${(props) => props.color};
      ${(props) => props.isRead? `background-color: ${colors.grey};`: null}
      position: absolute;
      width: 4px;
      top: 10px;
      bottom: 10px;
      border-radius: 50px;
    }

    .alertContent{
      width: calc(100% - 40px);
      display: flex;
      flex-direction: column;

      .alertTitle {
        font-size: 12px;
        height: 18px;
        line-height: 18px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        .alertType {
          color: ${(props) => props.isRead? colors.grey: props.color};
          font-weight: 600;
          margin: 0 10px;
        }
        .roomNumber {
          font-weight: 600;
          color: ${(props) => props.isRead? colors.grey: colors.yellow};
        }
      }
      
      .alertDetails {
        margin-left: 10px;
        height: 35px;
        justify-content: center;

        .alertInfo {
          font-weight: 600;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          .originator {
            margin-right: 10px;
            color: ${(props) => props.isRead? colors.grey: colors.silver};
          }

          .dateTime {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            color: ${(props) => props.isRead? colors.grey: colors.silver};

            /* & > span:last-child {
              position: relative;
              top: 1px;
              color: ${(props) => props.isRead? colors.grey: colors.red};
            } */
          }
        }

        .description {
          font-weight: 600;
          color: ${(props) => props.isRead? colors.grey: colors.white};
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    .priority {
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;
